/**
 * Created by matheusmorett on 24/08/17.
 */
import React, {Component} from 'react';
import FacebookLogin from 'react-facebook-login';
import { inject, observer } from 'mobx-react';
import Utils from 'utils/Utils';
import Alert from 'components/Alert';
import Button from 'components/Button';
import { t } from 'i18n';

import "./Login.scss";

@inject("AdventuresStore", "AuthStore" , "ApplicationStore")
@observer
class Login extends Component {

    static defaultProps = {
        openModal: () => {
        },
        closeModal: () => {
        },
        goToPage: () => {
        }
    };

    constructor(props) {
        super(props);

        this.state = {
            menuOpen: false,
            email: '',
            password: '',
            alert: false,
            emailRight: false,
            formError: {
                status: false,
                message: ""
            }
        };

    }


    componentWillReceiveProps(props) {
        this.setState({...props});
    }

    closeModal() {
        this.props.closeModal();
    }

    handleInputChange(e) {
        const name = e.target.name;
        const value = e.target.value;

        if(name === "email"){
            if(Utils.validateEmail(value) === false){
                this.setState({
                    emailRight: false
                });
            }else{
                this.setState({
                    emailRight: true
                });
            }
        }

        this.setState({
            [name]: value
        });
        this.checkFields(name);

    }

    checkFields(name) {
        if(this.state[name] === "" || this.state[name] === false || this.state[name] === undefined){
            this.setState({
                [name  + "Error"]: true
            });
            return false;
        }else{
            this.setState({
                [name  + "Error"]: false
            });
            return true;
        }
    }

    handleInputBlur(e) {
        const name = e.target.name;
        this.checkFields(name);
    }

    handleSubmitForm(e) {
        if(e) {
            e.preventDefault();
        }

        const { AuthStore, goToPage, ApplicationStore } = this.props;

        if(this.state.email !== "" && this.state.senha !== "" && this.state.emailRight === true){
            const params = {
                "email": this.state.email,
                "password": this.state.password
            };
            AuthStore.login(params).then((response) => {

                if(response.success) {
                    this.setState({
                        formError: {
                            status: false,
                            message: t('auth.loggedIn')
                        }
                    });
                    ApplicationStore.closeModal();
                    this.closeModal();
                    this.props.AdventuresStore.page = 1;
                    if (AuthStore.reloadPageAfterLogin) {
                        window.location.reload();
                    } else if(AuthStore.pageAfterLogin !== "") {
                        goToPage(AuthStore.pageAfterLogin);
                    }
                } else {
                    this.setState({
                        formError: {
                            status: true,
                            message: response.data.message
                        }
                    });
                }

            })
            .catch(err => {
                this.setState({
                    formError: {
                        status: true,
                        message: err.data.message
                    }
                });
            });
        } else {
            this.checkFields("email");
            this.checkFields("password");
        }

    }

    responseFacebook(response) {

        const { AuthStore, AdventuresStore, goToPage, ApplicationStore } = this.props;

        if(!response.email || !response.accessToken){
            this.setState({
                formError: {
                    status: true,
                    message: t('auth.facebookError')
                }
            });
            return
        }

        const params = {
            name: response.name,
            email: response.email,
            token: response.accessToken,
            photo: response.picture.data.url
        };

        AuthStore.loginSocial(params).then((response) => {

            if(response.success) {
                this.setState({
                    formError: {
                        status: false,
                        message: t('auth.loggedIn')
                    }
                });
                ApplicationStore.closeModal();
                AdventuresStore.page = 1;
                if (AuthStore.reloadPageAfterLogin) {
                    window.location.reload();
                } else if(AuthStore.pageAfterLogin !== "") {
                    goToPage(AuthStore.pageAfterLogin);
                }
            } else {
                this.setState({
                    formError: {
                        status: true,
                        message: t('auth.facebookError')
                    }
                });
            }

        });

    }

    handleForgotPassword() {
        const { ApplicationStore } = this.props;
        ApplicationStore.openModalForgotPassword();
    }

    handleGoToRegister() {
        const { ApplicationStore } = this.props;
        ApplicationStore.openModalRegister();
    }

    closeAlert() {
        this.setState({
           formError: {}
        });
    }

    render() {

        const { AuthStore } = this.props;

        return (
            <div className="Login">
                <div className="modal-content">
                    <div className="facebook-login">
                        <FacebookLogin
                            appId="342755846164051"
                            autoLoad={false}
                            fields="name,email,picture.width(500).height(500)"
                            callback={this.responseFacebook.bind(this)}
                            cssClass="btn btn-social btn-facebook btn-inner-card"
                            icon="fa-facebook"
                            isMobile={Utils.mobileCheck()}
                            disableMobileRedirect={true}
                            textButton={(AuthStore.loading ? <div><i className='fa fa-spinner fa-spin'></i></div> : <div>{t('auth.facebook')}</div>)}
                        />
                    </div>
                    <div className="Grid Grid-cell separator-or">
                        <div className="Grid-cell">
                            <hr />
                        </div>
                        <div className="Grid-cell text-quicksand-muted text-center">
                            {t('auth.or')}
                        </div>
                        <div className="Grid-cell">
                            <hr />
                        </div>
                    </div>
                    <form onSubmit={this.handleSubmitForm.bind(this)}>
                        <div className="  input-cell">
                            <div className="full-width group-input">
                                <input className="full-width"
                                       type="text"
                                       required
                                       value={this.state.email}
                                       onChange={this.handleInputChange.bind(this)}
                                       onBlur={this.handleInputBlur.bind(this)}
                                       name="email"
                                       autoComplete="off"
                                />
                                <span className="bar full-width"></span>
                                <span className="help-hasError">{(this.state.emailRight === false && this.state.emailError === false ? ' ' + t('validation.invalidField', { field: t('auth.email') }) : '')}</span>
                                <span className="help-hasError">{(this.state.emailError === true ? ' ' + t('validation.requiredField', { field: t('auth.email') }) : '')}</span>
                                <label>{t('auth.email')}</label>
                            </div>
                        </div>

                        <div className="  input-cell">
                            <div className="full-width group-input">
                                <input
                                    className="full-width"
                                    type="password"
                                    required
                                    value={this.state.password}
                                    onChange={this.handleInputChange.bind(this)}
                                    onBlur={this.handleInputBlur.bind(this)}
                                    name="password"
                                    autoComplete="off"
                                />
                                <span className="bar full-width"></span>
                                <span className="help-hasError">{(this.state.passwordError === true ? ' ' + t('validation.requiredField', { field: t('auth.password') }) : '')}</span>
                                <label>{t('auth.password')}</label>
                            </div>
                        </div>

                        <div className=" ">
                            <Alert formError={this.state.formError} closeAlert={this.closeAlert.bind(this)}/>
                        </div>

                        <div className=" ">
                            <Button loading={AuthStore.loading} type="primary" size="full">
                                {(AuthStore.loading ? <div><i className='fa fa-spinner fa-spin'></i></div> : <div>{t('auth.signinButton')}</div>)}
                            </Button>
                        </div>

                        <div className="other-links">
                            <div onClick={this.handleGoToRegister.bind(this)}>
                                {t('auth.signup')}
                            </div>
                            <div onClick={this.handleForgotPassword.bind(this)}>
                                {t('auth.forgot')}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}



export default Login;